import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';
import { DocumentDTO, DocumentStateDTO, DocumentVersionDTO, UserDTO } from '../../api/plyca-dtos';
import { ServiceLocator } from '../../ServiceLocator';
import { documentViewerComponent } from '../documentViewer/documentViewer.component';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { finalize, switchMap, take } from 'rxjs/operators';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { FieldConfig } from '../../api/contract-notice-dto';
import { FunctionDef } from '../../components/forms/form.objects';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { DATEPIPE_DATETIME_FORMAT } from '../../../services/language.service';

export class ViewModalHistory {
  documentParamId = 'Sin Información';
  constructor(documentParamId: string) {
    this.documentParamId = documentParamId;
  }
}

class StateVersionModel {
  versionNumber: number;
  stateId: any;
  stateDescription: string;
  comment: string;
  date: Date;
  user: UserDTO;
  isSigned: boolean;
  isVersion: boolean;
  isState: boolean;
  isLast: boolean;
}

@Component({
  selector: 'documentHistory',
  templateUrl: 'documentHistory.template.html',
  providers: [DialogService]
})
export class documentHistoryComponent extends BaseComponent implements OnDestroy {
  documentId: string = 'Sin Información';
  documento: DocumentDTO;
  windowHash: string;
  tagsParent: string[];
  public plycaService: PlycaDataService;
  private dialogService: DialogService;
  loaded = false;
  docVersionsAndStates: Array<any>;

  viewModes: Array<any> = [];
  MODE_ALL = 0;
  MODE_ONLY_STATES = 1;
  MODE_ONLY_VERSIONS = 2;
  selectedViewMode = this.MODE_ALL;
  public DATEPIPE_DATETIME_FORMAT = DATEPIPE_DATETIME_FORMAT;

  constructor(private route: ActivatedRoute,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    public translateService: TranslateService,
    public waitService: WaitLoadingService,
    public ref: DynamicDialogRef) {
    super();
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.DOCUMENT_HISTORY)
        }
      )));
    this.windowHash = generateRandomIdentifier();
    this.dialogService = ServiceLocator.injector.get(DialogService);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.waitService.startWaiting();

    // Si se abre este componente mediante enlace y parámetros
    this.route.params.subscribe(params => { this.documentId = params['id']; });

    // Si se abre este componente modalmente
    if (this.dialogConfig != null && this.dialogConfig['item'] != null) {
      this.documentId = this.dialogConfig['item'].documentParamId;
    }
    // this.userService = ServiceLocator.injector.get(UserService);
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {

        super.ngOnDestroy();
      })));
  }

  ngAfterContentInit(): void {
    this.initViewModes();
    this.loadDocument();
  }

  loadDocument(): void {
    this.subscribe(this.plycaService.getDocument(this.documentId, 'expand=expansionSet:HISTORY_WITH_USERS'),
      (param: DocumentDTO) => {
        this.documento = param;
        this.transformVersionAndStates();
        this.loaded = true;
        this.waitService.cancelWaiting();
      });
  }

  transformVersionAndStates() {
    console.log('trasnformVersionAndStates', this.selectedViewMode);
    let _docVersionsAndStates = [];
    if (this.selectedViewMode == this.MODE_ALL || this.selectedViewMode == this.MODE_ONLY_VERSIONS) {
      let _docversionHistory = this.documento.versionHistory;
      // if (_docversionHistory.length == 0) {
      //   _docversionHistory = [this.documento.currentVersion];
      // }
      // else {
      //   _docversionHistory.push(this.documento.currentVersion);
      // }

      _docversionHistory.forEach((version: DocumentVersionDTO) => {
        let _version = new StateVersionModel();
        _version.versionNumber = version.versionNumber;
        _version.date = version.date;
        _version.user = version.user;
        _version.isVersion = true;
        _version.isSigned = version.signers != undefined;
        _version.isLast = version.versionNumber == this.documento.currentVersion.versionNumber;
        _docVersionsAndStates.push(_version);
      });
      let _version = new StateVersionModel();
      _version.versionNumber = this.documento.currentVersion.versionNumber;
      _version.date = this.documento.currentVersion.date;
      _version.user = this.documento.currentVersion.user;
      _version.isVersion = true;
      _version.isSigned = this.documento.currentVersion.signers != undefined;
      _version.isLast = true;
      _docVersionsAndStates.push(_version);
    }


    if (this.selectedViewMode == this.MODE_ALL || this.selectedViewMode == this.MODE_ONLY_STATES) {
      this.documento.stateHistory.forEach((state: DocumentStateDTO) => {
        let _state = new StateVersionModel();
        _state.stateId = state?.type?.identifier;
        _state.stateDescription = state?.type?.description;
        _state.comment = state.comment;
        _state.date = state.date;
        _state.user = state.user;
        _state.isState = true;
        _docVersionsAndStates.push(_state);
      });

      // addCurrentState
      let currentState = new StateVersionModel();
      // this.documento.currentState
      currentState.stateId = this.documento.currentState?.type?.identifier;
      currentState.stateDescription = this.documento.currentState?.type?.description;
      currentState.comment = this.documento.currentState.comment;
      currentState.date = this.documento.currentState.date;
      currentState.user = this.documento.currentState.user;
      currentState.isState = true;
      currentState.isLast = true;
      _docVersionsAndStates.push(currentState);

    }
    _docVersionsAndStates.sort((a, b) => Number(a.date) - Number(b.date));
    this.docVersionsAndStates = _docVersionsAndStates;
  }

  // documentVisibles(): boolean {
  //   return (this.documento != null);
  // }

  // versionVisibles(): boolean {
  //   return (this.docversionHistory && this.docversionHistory.length > 0);
  // }

  public isLoaded(): boolean {
    return (this.documento != null && this.docVersionsAndStates != null);
  }

  public close() {
    console.log('cerrar');
    this.ref.close();
  }
  public showVersion(version: any): void {
    let config: DynamicDialogConfig = {
      header: this.documento.name + ' (Ver: ' + version.versionNumber + ')',
      width: '97%',
      styleClass: 'searchStyle'
    };

    config.data = {
      'id': this.documento.identifier,
      'version': version.versionNumber
    }

    let modal = this.dialogService.open(documentViewerComponent, config);
    modal.onClose.pipe(take(1)).subscribe();
  }

  initViewModes() {
    this.viewModes = [];
    this.viewModes.push({ label: 'Consultar estados y versiones', value: this.MODE_ALL });
    this.viewModes.push({ label: 'Consultar solo versiones', value: this.MODE_ONLY_VERSIONS });
    this.viewModes.push({ label: 'Consultar solo estados', value: this.MODE_ONLY_STATES });
  }

  public createFieldConfig(): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12 col-md-4';
    config.jsonField = 'selectedViewMode';
    config.type = 'DROPDOWN';
    config.description = '';
    config.dropDownDataKey = 'label';
    config.data = this.viewModes;
    config.onChangeFunction = 'transformVersionAndStates';
    config.visibility = 'true';
    config.editable = true;
    return config;
  }
  getFunctions() {
    let functions: Array<FunctionDef> = [];
    functions.push({
      identifier: 'transformVersionAndStates',
      fn: this.transformVersionAndStates.bind(this) // Para tener acceso al documentService
    });
    return functions;
  }
}
